export default "__VITE_ASSET__CxiUFIvr__"